<template>
  <div>
    <iframe
      id="iframe"
      width="100%"
      :height="height"
      align="middle"
      :srcdoc="mailing"
    />
  </div>
</template>

<script>
import base from '@/components/Content/Check/ContentCheckBase'

export default {
  data () {
    return {
      mailing: '',
      isDebug: false, // puppeteerが見ている画面確認用 (その際は php側のvalidationを無効にする)
      height: '',
    }
  },
  mixins: [ base ],
  mounted () {
    this.height = document.documentElement.scrollHeight
  },
  created () {
    let baseUrl = this.isDebug ? 'http://localhost:80/api' : process.env.VUE_APP_CAPTURE_BASE_URL
    const { type, id, jobId, capturePassword } = this.$route.params
    const url = `${baseUrl}/content/capture/${type}/${id}/${jobId}/${capturePassword}`
    fetch(url).then(resp => resp.json()).then(json => {
      if (json && json.status === 200) {
        const { sections, styles, originalStyle, originalHeadStyle } = json.data
        this.$store.commit('updateSections', sections)
        this.$store.commit('updateStyles', styles)
        this.$store.commit('setOriginalStyle', originalStyle)
        this.$store.commit('setOriginalHeadStyle', originalHeadStyle)
        const mobileCss = this.createMobileCSS()
        const headCss = this.createHeadCSS()
        const outlookCss = this.createOutlookCSS()
        this.createRawHTML()

        this.mailing = `
          <!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN" "http://www.w3.org/TR/html4/loose.dtd">
          <html>
          <head>
          <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=yes">
        `
        if (mobileCss) {
          this.mailing += `<style type="text/css" media="all">${mobileCss}</style>\n`
        }
        if (headCss) {
          this.mailing += `<style type="text/css" media="all">${headCss}</style>\n`
        }
        if (outlookCss) {
          this.mailing += `<!--[if gte mso 9]><style type="text/css" media="all">${outlookCss}</style><![endif]-->\n`
        }
        this.mailing += '</head>\n'

        // body
        this.mailing += `<body style="background-color: #FFFFFF; margin: 0 auto;">${this.rawHTML}</body>\n`
        this.mailing += '</html>\n'
        return
      }
      throw new Error()
    }).catch(() => {
      throw new Error('mphe-capture-job-failure-end')
    })
  }
}
</script>
